/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const SortIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="SortIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.99998 1.79291L6.35353 4.14646L5.64642 4.85357L4.49998 3.70712V12.2929L5.64642 11.1465L6.35353 11.8536L3.99998 14.2071L1.64642 11.8536L2.35353 11.1465L3.49998 12.2929V3.70712L2.35353 4.85357L1.64642 4.14646L3.99998 1.79291Z"
                fill="currentColor"
              />
              <path
                d="M7.99998 4.00001H14V5.00001H7.99998V4.00001Z"
                fill="currentColor"
              />
              <path
                d="M7.99998 7.00001H14V8.00001H7.99998V7.00001Z"
                fill="currentColor"
              />
              <path d="M7.99998 10H14V11H7.99998V10Z" fill="currentColor" />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

SortIcon.tags = [
  'arrows',
  'horizontal',
  'exchange',
  'sort',
  'order',
  'arrange',
  'filter',
];

SortIcon.category = 'General Icons';

SortIcon.iconSize = 16;
